var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell',{attrs:{"title":"账号资料","is-link":""},on:{"click":_vm.goAccount}}),_c('van-cell',{attrs:{"title":"修改密码","is-link":""},on:{"click":_vm.goReset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }